import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { Edit2 } from 'lucide-react';

const GroupSummaryCard = ({ group, onEdit }) => {
  if (!group) return null;
  return (
    <Card className="glass-card mb-4 p-3 premium-shadow animate-fade-in">
      <div className="d-flex align-items-center mb-3">
        {group.logoUrl && (
          <img
            src={group.logoUrl}
            alt="Group Logo"
            className="group-logo me-3"
            style={{ width: 56, height: 56, borderRadius: 16, objectFit: 'cover', boxShadow: '0 2px 16px rgba(0,0,0,0.12)' }}
          />
        )}
        <div>
          <h3 className="fw-bold mb-1 gradient-text">{group.name}</h3>
          <div className="text-muted">{group.website && <a href={group.website} target="_blank" rel="noopener noreferrer">{group.website}</a>}</div>
        </div>
        <Button variant="outline-primary" className="ms-auto" onClick={onEdit} size="sm">
          <Edit2 size={18} className="me-1" /> Edit
        </Button>
      </div>
      <div className="mb-2">{group.description}</div>
      {group.contact && (
        <div className="small text-muted">
          <span className="fw-semibold">Contact:</span> {group.contact.name} &bull; {group.contact.email} &bull; {group.contact.phone}
        </div>
      )}
    </Card>
  );
};

export default GroupSummaryCard;
